import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { map, shareReplay, switchMap, catchError, filter, withLatestFrom } from 'rxjs/operators';

import { LpFundDataService } from 'src/app/services/lp/lp-fund-data.service';
import { LpHoldingService } from '../../shared/holdings/lp-holding.service';
import HTTP_STATUS_CODES from 'src/app/shared/enums/HttpStatusCodesEnum';
import { RoutingService } from 'src/app/services/routing.service';
import { StorageObjectDataService } from 'src/app/services/shared/storage-object-data.service';
import HoldingDiscriminator from 'src/app/shared/enums/HoldingDiscriminator.enum';
import { TerraNumberPipe } from 'src/app/shared/pipes/TerraNumber.pipe';
import { LpHoldingDataService } from 'src/app/services/lp/lp-holding-data.service';
import { LpFundListItemReqRes } from '../LpFundListItemReqRes.model';
import { LoggerService } from 'src/app/shared/errors/logger.service';
import { AlertDialogParams } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { DialogService } from 'src/app/services/dialog.service';
import { UserService } from 'src/app/services/shared/user.service';
import { LpInvestingEntityDataService } from 'src/app/services/lp/lp-investing-entity-data.service';

@Injectable()
export class LpFundService extends LpHoldingService {

  readonly holdingDiscriminator = HoldingDiscriminator.Fund;

  reportId$ = this.route.queryParams.pipe(
    map(params => {
      return +params.reportId || null;
    }),
    shareReplay(1)
  );

  fund$ = this.holdingId$.pipe(
    withLatestFrom(this.userService.accountDetails$),
    filter(([id,accountDetails])  => this.checkSameEmails(accountDetails.userName, HoldingDiscriminator.Fund)),
    map(([id,accountDetails]) => id),
    switchMap(id => this.lpFundDataService.getById(id)),
    catchError(err => {
      if (err.status == HTTP_STATUS_CODES.NOT_FOUND) {
        this.router.navigateByUrl(this.routingService.lpHomePage);
      }
      return throwError(err)
    }),
    shareReplay(1));

  holdingDetails$ = this.fund$;

  transactions$ = this.fund$.pipe(map(fund => fund.transactions), shareReplay(1));

  status$ = this.fund$.pipe(map(fund => fund.status));

  constructor(
    private storageObjectDataService: StorageObjectDataService,
    private lpFundDataService: LpFundDataService,
    private route: ActivatedRoute,
    private router: Router,
    private routingService: RoutingService,
    private datePipe: DatePipe,
    private terraNumberPipe: TerraNumberPipe,
    private lpHoldingDataService: LpHoldingDataService,
    private logger: LoggerService,
    private dialogService: DialogService,
    private userService: UserService,
    private lpInvestingEntityDataService: LpInvestingEntityDataService
  ) {
    super(
      storageObjectDataService, routingService, router, route, lpFundDataService,
      datePipe, terraNumberPipe, lpHoldingDataService, logger, userService, dialogService,lpInvestingEntityDataService);
  }

  getPendingFundsList(): Observable<LpFundListItemReqRes[]> {
    return this.lpFundDataService.getPendingFunds();
  }

  getFundsOpportunitiesList(): Observable<LpFundListItemReqRes[]> {
    return this.lpFundDataService.getFundsOpportunities();
  }
}
